import { Alert, Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { RedactionOptions } from "../../api/transcription";
import { useTranslation } from "react-i18next";

type RedactionOptionFieldsProps = {
  options:RedactionOptions;
  onChange: (next: RedactionOptions) => void;
  disabled: boolean;
  variant: "required" | "optional";
}

export default function RedactionOptionFields({
  options,
  onChange,
  disabled,
  variant
}: RedactionOptionFieldsProps) {
  const { t } = useTranslation(["transcription"]);

  const financial = options.piiToRedact?.financial ?? false;
  const personal = options.piiToRedact?.personal ?? false;
  const nothingSelected = !financial && ! personal;


   const update = (next: { financial: boolean; personal: boolean }) => {
     onChange({
       enabled: next.financial || next.personal,
       piiToRedact: next,
     });
   };


  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={financial}
              onChange={(e) =>
                update({ financial: e.target.checked, personal })
              }
              disabled={disabled}
            />
          }
          label={
            <Box>
              <Typography variant="body1" fontWeight="medium">
                {t("transcription:financialRedactionOption")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t("transcription:financialRedactionDescription")}
              </Typography>
            </Box>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={personal}
              onChange={(e) =>
                update({ financial, personal: e.target.checked })
              }
              disabled={disabled}
            />
          }
          label={
            <Box>
              <Typography variant="body1" fontWeight="medium">
                {t("transcription:personalRedactionOption")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t("transcription:personalRedactionDescription")}
              </Typography>
            </Box>
          }
        />
      </FormGroup>

      {nothingSelected && (
        <Alert severity={variant === "required" ? "warning" : "info"} sx={{ mt: 2 }}>
          {variant === "required"
            ? t("transcription:mustSelectRedactionOption")
            : t("transcription:noRedactionOptionsSelected")}
        </Alert>
      )}
    </>
  );
}